<template>
  <div>
    <progressive-img
      id="pimg"
      v-for="i in albums[id].size"
      :src="getImageSource(id, i)"
      :placeholder="getImagePlaceholder(id, i)"
      :key="i"
    />
  </div>
</template>

<script>
  import albums from "../assets/albums.json";
  export default {
    name: "Gallery",
    props: ["id"],
    methods: {
      getImageSource: function(id, index) {
        let filename = `${index}`.padStart(4, "0");
        return `/albums/${id}/${filename}.jpg`;
      },
      getImagePlaceholder: function(id, index) {
        let filename = `${index - 1}`.padStart(4, "0");
        return `/albums/${id}/thumb_${filename}.jpg`;
      }
    },
    data() {
      return {
        albums
      };
    }
  };
</script>

<style scoped>
  #pimg {
    max-width: 960px;
    margin: auto;
  }
  @media screen and (min-width: 700px) {
    #pimg {
      margin-bottom: 10px;
    }
  }
  @media screen and (max-width: 700px) {
    #pimg {
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Album.vue